import InputErrors from '../partials/InputErrors';

export default {
    components: {
        InputErrors,
    },

    props: {
        input: {
            type: Object,
            required: true,
        },
    },

    computed: {
        inputValue: function () {
            return this.input.value;
        },

        hasChanges: function () {
            return this.input.initialValue !== this.input.value;
        },

        hasError: function () {
            return this.input.errors.length > 0;
        },
    },

    methods: {
        clearErrors: function () {
            this.input.errors = [];
        },
    },

    watch: {
        input: function () {
            this.input.initialValue = this.input.value;
        },

        inputValue: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.clearErrors();
            }
        },
    },
}
